export default {
  getMarker(state, getters, rootState) {
    const { data } = rootState.rawData;
    const markerData = [];

    Object.values(data).forEach((item) => {
      const {
        ...rest
      } = item;
      const marker = rest;

      marker.address = item.Postcode;
      marker.position = item.coords;

      markerData.push(marker);
    });

    return markerData;
  },
};
